import { render, staticRenderFns } from "./UserHelp.vue?vue&type=template&id=095bb70f&scoped=true&"
import script from "./UserHelp.vue?vue&type=script&lang=js&"
export * from "./UserHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095bb70f",
  null
  
)

export default component.exports